import {
  takeEvery,
  fork,
  put,
  all,
  call,
} from "redux-saga/effects";

import {
  GET_UNUSED_DEALERS,
} from "./actionTypes";

import {
  GetUnusedDealersSuccessful,
  GetUnusedDealersFailed,
} from "./actions";

import { getList } from "../../helpers/fackBackend_Helper";

function* getUnusedDealersResponse({ payload: { data } }) {
  try {

    const response = yield call(
      getList,
      `/getUnusedDealers/${data.companyID}/${data.channelID}`
    );

    if (response.Status) {
      yield put(GetUnusedDealersSuccessful(response.data));
    } else {
      yield put(GetUnusedDealersFailed(response.Message));
    }

  } catch (error) {
    yield put(GetUnusedDealersFailed(error));
  }
}

export function* watchgetUnusedDealers() {
  yield takeEvery(
    GET_UNUSED_DEALERS,
    getUnusedDealersResponse
  );
}

function* unusedDealersSaga() {
  yield all([
    fork(watchgetUnusedDealers),
  ]);
}

export default unusedDealersSaga;